var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"payment-btn white--text",attrs:{"block":"","x-large":"","height":"56","loading":_vm.loading,"disabled":_vm.disabled || _vm.loading,"elevation":"2"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"text-h6 font-weight-bold letter-spacing-1"},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }